import React, { useContext } from 'react';
import { ErrorModalIcon } from '../../assets/icons';
import tableContext from './tableContext';
import TableRow from './TableRow';

type Props = {
    text: string;
};

const EmptyDataRow: React.FC<Props> = ({ text }) => {
    const { numOfColumns } = useContext(tableContext);

    if (!numOfColumns) return null;

    return (
        <TableRow
            className='empty-data-row'
            style={{ gridColumn: `1/${numOfColumns + 1}` }}
        >
            <div className='empty-data-row-container'>
                <ErrorModalIcon />
                <span>{text}</span>
            </div>
        </TableRow>
    );
};

export default EmptyDataRow;
